import products from "../../../data/product-data.json" with { type: "json" };
export const noSerialProducts = [
    "FFI0001-0000",
    "FFL0002-0000",
    "FFL0003-0000",
    "FFL0004-0000",
    "FFL1000-1",
    "FFL2100-0",
    "FIS1100-0600",
    "FNA1000-0400",
    "FVK1202-0",
    "FVK2200-0300",
    "FVK2201-0300",
    "FVK2202-0300",
    "FVK3210-0",
    "FVK3220-0",
    "FVK3230-0",
    "FVK3240-0",
    "FVK4224-0",
    "FVK4225-0",
    "VKA10-GH",
    "FFL0001-0000",
    "FFL2000-0",
    "FFL2200-0",
    "FIL5100-0145",
    "VSW05-SG",
    "FFL0005-0000",
    "FFL3000-0",
    "FFL3100-0",
    "FFL3200-0",
    "FVK4215-0",
    "FFI0002-0000",
    "KBRE2-SG",
    "ZAM1101-0010",
    "ZAS1312-0010",
    "ZAS1334-0010",
    "ZAS1356-0010",
    "ZAU4001-0002",
    "ZIA5001-0145",
    "ZIA5003-0145",
    "ZIA5005-0145",
    "ZIA5006-0145",
    "ZIT3030-0010",
    "ZIT3222-0030",
    "ZIT5000-0030"
]
const allProducts = [
    ...products.indoorstations,
    ...products.outdoorstations,
    ...products.controlUnits,
    ...products.Gateway,
    ...products.Funktionserweiterung
]
export const allProductsRequiringSerial = allProducts.filter(
    p => !noSerialProducts.includes(p)
);